import { inject, Injector, type Provider } from '@angular/core';
import { ChatPanelStore } from '@modules/chat/services/chat-panel.service';
import { SpaceContextStore } from '@modules/common/services/SpaceContextStore';
import { FORM_STITCHY_CREATE, type FormStitchyCreate } from '../components/shared/form-stitchy-create';

/** Boards' native assistant hand-off; the Forms wording targets the existing PRIVATE form, never publishes or sends it. */
export function formStitchyCreate(injector: Injector): FormStitchyCreate {
  return ({ formId, space, prompt }) => {
    const context = injector.get(SpaceContextStore);
    if (!space || context.contextId() !== space) throw Error('The workspace changed before asking Stitchy.');
    const chat = (context.contextInjector ?? injector).get(ChatPanelStore);
    chat.clearActiveConversation();
    chat.open();
    chat.sendMessage(`Create a form in the existing form ${formId}, in space ${space ?? 'personal'}. Keep its folder unchanged. Keep it private unless the user asks to share it. Request: ${prompt}`);
  };
}
export const FORM_STITCHY_CREATE_PROVIDER: Provider = {
  provide: FORM_STITCHY_CREATE,
  useFactory: () => formStitchyCreate(inject(SpaceContextStore).contextInjector ?? inject(Injector)),
};
